import apiClient from './apiClient';

export const organizationsApi = {
	// Organization endpoints

	// Create a new organization
	create: async (data) => {
		try {
			const response = await apiClient.post('/api/organizations', data);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to create organization'
			);
		}
	},

	// Get a single organization by ID
	getOne: async (orgId) => {
		try {
			const response = await apiClient.get(`/api/organizations/${orgId}`);
			return response.data;
		} catch (error) {
			console.error('API Error:', {
				status: error.response?.status,
				data: error.response?.data,
			});
			throw new Error(
				error.response?.data?.message || 'Failed to fetch organization'
			);
		}
	},

	// Update an organization by ID
	update: async (orgId, data) => {
		try {
			const response = await apiClient.patch(
				`/api/organizations/${orgId}`,
				data
			);
			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to update organization'
			);
		}
	},

	// Get all organizations with optional search
	getAll: async (search = '') => {
		try {
			const response = await apiClient.get('/api/organizations', {
				params: { search },
			});

			return response.data;
		} catch (error) {
			throw new Error(
				error.response?.data?.message || 'Failed to fetch organizations'
			);
		}
	},

	// Teams endpoints
	teams: {
		getAll: async (orgId) => {
			try {
				const response = await apiClient.get(
					`/api/organizations/${orgId}/teams`
				);
				return response.data;
			} catch (error) {
				throw new Error(
					error.response?.data?.message || 'Failed to fetch teams'
				);
			}
		},

		getOne: async (orgId, teamId) => {
			try {
				const response = await apiClient.get(
					`/api/organizations/${orgId}/teams/${teamId}`
				);
				return response.data;
			} catch (error) {
				throw new Error(
					error.response?.data?.message || 'Failed to fetch team'
				);
			}
		},

		getMembers: async (orgId, teamId) => {
			try {
				const response = await apiClient.get(
					`/api/organizations/${orgId}/teams/${teamId}/users`
				);
				return response.data;
			} catch (error) {
				throw new Error(
					error.response?.data?.message ||
						'Failed to fetch team members'
				);
			}
		},

		create: async (orgId, teamData) => {
			try {
				const response = await apiClient.post(
					`/api/organizations/${orgId}/teams`,
					teamData
				);
				return response.data;
			} catch (error) {
				throw new Error(
					error.response?.data?.message || 'Failed to create team'
				);
			}
		},

		update: async (orgId, teamId, teamData) => {
			try {
				const response = await apiClient.patch(
					`/api/organizations/${orgId}/teams/${teamId}`,
					teamData
				);
				return response.data;
			} catch (error) {
				throw new Error(
					error.response?.data?.message || 'Failed to update team'
				);
			}
		},

		delete: async (orgId, teamId) => {
			try {
				const response = await apiClient.delete(
					`/api/organizations/${orgId}/teams/${teamId}`
				);
				return response.data;
			} catch (error) {
				throw new Error(
					error.response?.data?.message || 'Failed to delete team'
				);
			}
		},

		addMembers: async (orgId, teamId, data) => {
			try {
				const response = await apiClient.post(
					`/api/organizations/${orgId}/teams/${teamId}/users`,
					data
				);
				return response.data;
			} catch (error) {
				console.error('Error adding team members:', error);
				throw new Error(
					error.response?.data?.message ||
						'Failed to add team members'
				);
			}
		},
	},

	getById: async (id) => {
		try {
			const response = await apiClient.get(`/api/organizations/${id}`);
			return response.data;
		} catch (error) {
			console.error('Error fetching organization:', error);
			throw error;
		}
	},
};
